// extracted by mini-css-extract-plugin
export var bodySections = "_6m-8";
export var gray = "_6m-7";
export var green = "_6m-4";
export var iconContainer = "_6m-9";
export var iconWidgetContainer = "_6m-1";
export var phoneIcon = "_6m-2";
export var red = "_6m-5";
export var statusDot = "_6m-3";
export var widgetContainer = "_6m-0";
export var yellow = "_6m-6";